import React, { useState, useEffect } from 'react';

const CategoryForm = ({ initialData, onSubmit, onCancel, isSubmitting = false }) => {
  const [formData, setFormData] = useState({
    name: '',
    isDeleted: false,
    isTutorials: false
  });
  const [errors, setErrors] = useState({});

  useEffect(() => {
    if (initialData) {
      setFormData({
        name: initialData.name || '',
        isDeleted: initialData.isDeleted || false,
        isTutorials: initialData.isTutorials || false,
      });
    } else {
      setFormData({
        name: '',
        isDeleted: false,
        isTutorials: false
      });
    }
  }, [initialData]);

  const validateForm = () => {
    const newErrors = {};
    if (!formData.name.trim()) {
      newErrors.name = 'Name is required';
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (validateForm()) {
      await onSubmit(formData);
    }
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
    if (errors[name]) {
      setErrors(prev => ({ ...prev, [name]: '' }));
    }
  };

  return (
    <form onSubmit={handleSubmit} className="admin-crud-form">
      <div className="admin-crud-form-group">
        <label className="admin-crud-label admin-crud-label-required">Category Name</label>
        <input
          type="text"
          name="name"
          className={`admin-crud-input ${errors.name ? 'admin-crud-input-error' : ''}`}
          value={formData.name}
          onChange={handleChange}
          placeholder="Enter category name"
        />
        {errors.name && <div className="admin-crud-error-message">{errors.name}</div>}
      </div>

      <div className="admin-crud-form-group">
        <div className="admin-crud-switch">
          <span className="admin-crud-switch-label">Tutorials Category</span>
          <input
            type="checkbox"
            name="isTutorials"
            checked={formData.isTutorials}
            onChange={handleChange}
          />
        </div>
        <small className="admin-crud-empty-subtext">
          Enable for Tutorials, disable for Blogs
        </small>
      </div>

      <div className="admin-crud-form-group">
        <div className="admin-crud-switch">
          <span className="admin-crud-switch-label">Status</span>
          <input
            type="checkbox"
            name="isDeleted"
            checked={formData.isDeleted}
            onChange={handleChange}
          />
        </div>
        <small className="admin-crud-empty-subtext">
          Enable to deactivate this category
        </small>
      </div>

      <div className="admin-crud-modal-footer" style={{ padding: '20px 0 0 0' }}>
        <button 
          type="button"
          className="admin-crud-btn admin-crud-btn-secondary" 
          onClick={onCancel} 
          disabled={isSubmitting}
        >
          Cancel
        </button>
        <button 
          type="submit" 
          className="admin-crud-btn admin-crud-btn-primary" 
          disabled={isSubmitting}
        >
          {isSubmitting ? 'Saving...' : initialData ? 'Update Category' : 'Create Category'}
        </button>
      </div>
    </form>
  );
};

export default CategoryForm;